import { useForm, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { DialogContent, DialogActions } from '@mui/material';
import { useAuth } from '@app/api/auth/useAuth';
import { ThemeButton } from '@shared/ui/buttons';
import { CodePinInput } from '@shared/ui/forms/inputs';
import { validateServerErrors } from '@utils/validation';

export default function DisableTwofaDialog({ close }) {
  const { disableTwofa } = useAuth();
  const { t } = useTranslation();
  const {
    control,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      otp: '',
    },
  });
  const otpWatch = useWatch({ control, name: 'otp' });

  async function onSubmit(data) {
    try {
      const res = await disableTwofa(data);
      if (res) close();
    } catch (err) {
      validateServerErrors(setError, err);
    }
  }

  return (
    <>
      <DialogContent className="twoFa">
        <CodePinInput
          control={control}
          name="otp"
          error={errors.otp}
          label={t('enter_2fa_code')}
        />
      </DialogContent>
      <DialogActions>
        <ThemeButton
          onClick={handleSubmit(onSubmit)}
          startIcon="check"
          loading={isSubmitting}
          disabled={otpWatch.length < 6}
        >
          {t('submit')}
        </ThemeButton>
      </DialogActions>
    </>
  );
}
